const { createAction } = require("../../helpers");
const {
  GET_PROVIDER_LIST,
  GET_PROVIDER_LIST_SUCCESS,
  GET_PROVIDER_LIST_ERROR,
  GET_PROVIDER_LIST_RESET,

  OZOPAY_PAYMENT,
  OZOPAY_PAYMENT_SUCCESS,
  OZOPAY_PAYMENT_ERROR,
  OZOPAY_PAYMENT_RESET,

  OZOPAY,
  OZOPAY_SUCCESS,
  OZOPAY_ERROR,
  OZOPAY_RESET,
} = require("./constants");

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */

const getPaymentProviderList = () => createAction(GET_PROVIDER_LIST);
const getPaymentProviderListSuccess = (data) =>
  createAction(GET_PROVIDER_LIST_SUCCESS, { data });
const getPaymentProviderListError = (error) =>
  createAction(GET_PROVIDER_LIST_ERROR, { error });
const getPaymentProviderListReset = () => createAction(GET_PROVIDER_LIST_RESET);

const ozopayPayment = (transactionId, data) =>
  createAction(OZOPAY_PAYMENT, { transactionId, data });
const ozopayPaymentSuccess = (data) =>
  createAction(OZOPAY_PAYMENT_SUCCESS, { data });
const ozopayPaymentError = (error) =>
  createAction(OZOPAY_PAYMENT_ERROR, { error });
const ozopayPaymentReset = () => createAction(OZOPAY_PAYMENT_RESET);

const ozopay = (uuid) => createAction(OZOPAY, { uuid });
const ozopaySuccess = (data) => createAction(OZOPAY_SUCCESS, { data });
const ozopayError = (error) => createAction(OZOPAY_ERROR, { error });
const ozopayReset = () => createAction(OZOPAY_RESET);

module.exports = {
  getPaymentProviderList,
  getPaymentProviderListSuccess,
  getPaymentProviderListError,
  getPaymentProviderListReset,

  ozopayPayment,
  ozopayPaymentSuccess,
  ozopayPaymentError,
  ozopayPaymentReset,

  ozopay,
  ozopaySuccess,
  ozopayError,
  ozopayReset,
};
